import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { NonprofitService } from '@features/nonprofit/nonprofit.service';

export const sdgResolver: ResolveFn<void> = () => {
  return inject(NonprofitService).setSdgMetadata();
};
